import { createAction } from '@reduxjs/toolkit';

const removeAssetProductLinks = createAction('asset/removeAssetProductLinks');

export default removeAssetProductLinks;
